export default __webpack_public_path__ + "061f4953da41f1682a5ae5d74faba0f0.png";